import { render } from "./DashboardHeader.vue?vue&type=template&id=50987210&scoped=true"
import script from "./DashboardHeader.vue?vue&type=script&lang=js"
export * from "./DashboardHeader.vue?vue&type=script&lang=js"

import "./DashboardHeader.vue?vue&type=style&index=0&id=50987210&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50987210"]])

export default __exports__